/* eslint-disable @angular-eslint/directive-selector, @angular-eslint/directive-class-suffix */

import { computed, Directive, input } from '@angular/core';
import { SingleRenderInSourceDirectiveBase } from 'common-ui';
import { CartItemResultRenderTarget, CartItemResultRenderTargetComponents } from './CartItemResultRenderTargetComponents';

@Directive({
  selector: '[renderInCartItemResultLayout]',
  standalone: true,
})
export class RenderInCartItemResultLayoutDirective extends SingleRenderInSourceDirectiveBase {
  public override renderArgs = input<string | undefined>(undefined, { alias: 'renderInCartItemResultLayoutId' });
  public override priority = input<number>(0, { alias: 'renderInCartItemResultLayoutPriority' });
  public readonly target = input<CartItemResultRenderTarget, CartItemResultRenderTarget | string | undefined>(
    CartItemResultRenderTarget.Info,
    {
      alias: 'renderInCartItemResultLayout',
      transform: (value) => (value as CartItemResultRenderTarget) ?? CartItemResultRenderTarget.Info,
    },
  );
  protected readonly renderIn = computed(
    () => CartItemResultRenderTargetComponents[this.target()] || CartItemResultRenderTargetComponents[CartItemResultRenderTarget.Info],
  );
}
